import { fromMinorUnits } from '@/api/map/agent'
import { fromMinorUnitsSigned } from '@/api/map/pnl'
import type { Bet, BetStatus } from '@/data/types'

/** bet-service OpenAPI `Bet`. */
export interface AnalyticsServiceBet {
  betId: string
  memberId: string
  marketId: string
  selectionId: string
  stake: string
  oddsMilli: number
  status: 'open' | 'won' | 'lost' | 'voided'
  holdTransferId?: string
  pnl: string | null
  payout: string | null
  settledAt: string | null
  replayed?: boolean
  createdAt?: string
}

function mapStatus(status: AnalyticsServiceBet['status']): BetStatus {
  switch (status) {
    case 'open':
      return 'matched'
    case 'won':
    case 'lost':
      return 'settled'
    case 'voided':
      return 'void'
    default:
      return 'matched'
  }
}

/**
 * Map bet-service bet → console Bet.
 * Event/market names and side are not on the wire — show ids, default side back.
 */
export function toConsoleBet(row: AnalyticsServiceBet): Bet {
  const stake = fromMinorUnits(row.stake)
  const odds = row.oddsMilli / 1000
  const pnl = row.pnl == null ? undefined : fromMinorUnitsSigned(row.pnl)
  const result =
    row.status === 'won' ? 'won' : row.status === 'lost' ? 'lost' : row.status === 'voided' ? 'void' : undefined

  const placedAt = row.createdAt ?? row.settledAt ?? new Date().toISOString()
  const status = mapStatus(row.status)
  return {
    id: row.betId,
    memberId: row.memberId,
    placedAt,
    matchedAt: status === 'matched' || status === 'settled' ? placedAt : null,
    sport: 'Cricket',
    eventId: row.marketId,
    eventName: row.marketId,
    marketId: row.marketId,
    marketName: row.marketId,
    marketType: 'Match Odds',
    selection: row.selectionId,
    side: 'back',
    oddsPlaced: odds,
    oddsMatched: odds,
    stake,
    matched: stake,
    unmatched: 0,
    liability: stake,
    potentialProfit: Math.max(0, stake * (odds - 1)),
    status,
    result,
    pnl,
  }
}
